/**
 * 四大旗舰版活动模式
 * @author  Ta_Mu
 * @date 2021/5/18 11:46
 */

// 付费后置
export const SIDA_PAID_POST = 1
// 限时免费
export const SIDA_FREE_FOR_LIMIT_TIME = 2
